import { AxiosResponse } from 'axios';
import { RoleRequest } from 'types/entity';
import { RoleListResponse } from 'types/entity/role-list-response';
import { RoleModel } from 'types/entity/role-model';
import { http } from './settings';

export const fetchProjectUnusedRoles = (projectId: string): Promise<RoleModel[]> => http.get(`/projects/${projectId}/roles/unused`)
  .then((value: AxiosResponse<RoleListResponse>) => value.data.roles || []);

export const addRole = (projectId: string, role: RoleRequest): Promise<void> => http.put(`/projects/${projectId}/roles`, role);

export const deleteRole = (projectId: string, roleCode: string): Promise<void> => http.delete(`/projects/${projectId}/roles/${roleCode}`);
